module.exports = __webpack_public_path__ + "media/images/opengraph_share_default_en-969ca7df1ac57af3192e92ee5543afc6.jpg";